<div class="backdrop"></div>
<kion-sidebar *ngIf="filterMobileVisible">
  <div class="filter-header">
    <div class="action" (click)="toggleFilterMobile()"> <img src="./assets/icons/arrow_left_icon.svg" alt="close_icon_left" title="close_icon_left" /> {{ 'filter.headline' | translate }} </div>
    <div class="results" *ngIf="pagination$ | async as pagination">{{ 'filter.results' | translate:{count: pagination.total} }}</div>
  </div>
  <div class="category-nav">
    <kion-category-navigation [page]="page" [title]="'filter.categoryNav.headline' | translate"></kion-category-navigation>
  </div>
  <div class="sort">
    <kion-drop-down
      [options]="sorts$ | async"
      [title]="'filter.sort.by' | translate"
      [showDropDownOnClick]="true"
      selectedOptionPosition="behind"
      [showSelectedOption]="true"
      [showArrowIcon]="true"
      (selected)="sortSelected($event)"
    ></kion-drop-down>
  </div>
  <div class="filter">
    <kion-filter-bar
      [filter]="facets$ | async"
      (filterToggled)="filterToggled()"
      (addFilter)="addFilter($event)"
      (removeFilter)="removeFilter($event)"
      (removeAllFilter)="removeAllFilter()"
    ></kion-filter-bar>
  </div>
</kion-sidebar>
<div class="mobile-filter-bar">
  <div class="sidebar" (click)="toggleFilterMobile()">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <g fill="none" fill-rule="evenodd">
        <g fill="#000">
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <g>
                      <path d="M8.571 18.571c-.394 0-.714-.32-.714-.714v-6.214L2.621 3.786c-.216-.326-.235-.744-.05-1.088.185-.344.545-.557.936-.555h12.986c.392-.001.752.214.936.56.184.346.162.765-.058 1.09l-5.228 7.85v4.071c0 .225-.106.437-.286.572L9 18.429c-.124.092-.274.142-.429.142zm-4.378-15l5 7.465c.068.119.1.255.093.393v5l1.428-1.072V11.43c.001-.14.044-.277.122-.393l4.971-7.465H4.193z" transform="translate(-40 -374) translate(0 115) translate(0 246) translate(40 10) translate(0 3)"/>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
    {{ 'filter.headline' | translate }}
  </div>
  <div class="results" *ngIf="pagination$ | async as pagination">
    {{ 'filter.results' | translate:{count: pagination.total} }}
  </div>
</div>
<div class="search-result-list-container">
  <div class="content" *ngIf="(products$ | async)?.length > 0; else noResult">
    <div class="filter-bar with-filter">
      <kion-filter-bar
        [filter]="facets$ | async"
        (filterToggled)="filterToggled()"
        (addFilter)="addFilter($event)"
        (removeFilter)="removeFilter($event)"
        (removeAllFilter)="removeAllFilter()">
        <div class="category-nav">
          <kion-category-navigation
            [page]="page"
            [noClose]="true"
            [single]="true"
          ></kion-category-navigation>
        </div>
      </kion-filter-bar>
      <div class="results" *ngIf="pagination$ | async as pagination">
        {{ 'filter.results' | translate:{count: pagination.total} }}
      </div>
    </div>
    <div class="products">
      <div class="sort-bar">
        <div class="spacer"></div>
        <div class="sort">
          <kion-drop-down
            [options]="sorts$ | async"
            [title]="'filter.sort.by' | translate"
            [showDropDownOnClick]="true"
            selectedOptionPosition="behind"
            [showSelectedOption]="true"
            (selected)="sortSelected($event)"
          ></kion-drop-down>
        </div>
      </div>
      <div class="grid with-filter" *ngIf="products$ | async as products">
        <div class="items" *ngIf="products.length > 0">
          <kion-product-card
            *ngFor="let product of products"
            [product]="product"
            [forceNetto]="true"
          ></kion-product-card>
        </div>
      </div>
      <kion-pagination
        *ngIf="pagination$ | async as pagination"
        [totalPages]="pagination.totalPages"
        [currentPage]="pagination.page"
        [currentPerPage]="pagination.perPage"
        (perPageChanged)="updatePerPage($event)"
        (pageChanged)="updatePage($event)"
      ></kion-pagination>
    </div>
  </div>
  <ng-template #noResult>
    <div class="content">
      <div class="no-content" #noContent></div>
    </div>
  </ng-template>
</div>
